// Pure SVG point-math for the logins/active-users line chart. Extracted from
// logins_chart.vue so it can be unit tested without a DOM/@vue/test-utils
// (neither is set up in this project's vitest config).
export function linePoints (values, { width, height, pad, max } = {}) {
  const n = values.length
  if (n === 0) return ''

  const scaleMax = max ?? Math.max(1, ...values)

  return values.map((v, i) => {
    const x = pad + (i * (width - pad * 2)) / Math.max(1, n - 1)
    const y = height - pad - (v / scaleMax) * (height - pad * 2)
    return `${x.toFixed(1)},${y.toFixed(1)}`
  }).join(' ')
}
